<div class="iam-topbar">
  <div class="iam-topbar-left">
    <div class="p-pt-1 p-pl-3">
      <a routerLink="/" title="Home Casta Invoice">
        <img src="assets/homecasta/IAM-Logo.png" alt="Home Casta Invoice" style="height: 4rem">
      </a>
    </div>
  </div>
  <div class="iam-topbar-right">
    <div class="iam-topbar-menu">

    </div>
    <ul class="iam-topbar-actions">
      <li class="iam-topbar-action">
        <span class="p-d-flex p-ai-center" style="position: relative;">
                     <button #mobileButton pButton type="button" class="p-button-outlined p-d-flex p-ai-center" (click)="mobileAppMenu.toggle($event)">
             <i class="pi pi-mobile p-mr-2"></i>
             <span>Mobile app hóa đơn&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
           </button>
           <img src="assets/images/new.png" alt="NEW" style="position: absolute; right:-1px; height: 40px; z-index: 10;"/>
        </span>
        <p-menu #mobileAppMenu [popup]="true" [appendTo]="'body'" [model]="mobileAppMenuItems" [style]="{minWidth: (mobileButton?.offsetWidth || 220) + 'px'}"></p-menu>
        <a pRipple class="p-d-flex p-flex-row p-ai-center" *ngIf="AuthService.hasRoles(['Customer'])" (click)="showProductList()" title="Mua gói">
          <p-button label=" Mua gói" icon="pi pi-shopping-cart" styleClass="p-button-outlined"></p-button>
        </a>
        <a pRipple class="p-d-flex p-flex-row p-ai-center" href="https://zalo.me/2754224749728949264" target="_blank" title="Hỗ trợ trực tiếp">
          <img src="assets/images/zalo-60x60.png" alt="" class="p-mr-3" width="30">
          <span>Hỗ trợ trực tiếp</span>
        </a>
        <a pRipple class="p-d-flex p-flex-row p-ai-center" (click)="entities.onTopbarActionClick($event, 'ShowSupport')" title="Hotline">
          <img src="assets/images/support.png" alt="" class="p-mr-3" width="30">
          <span>Hotline: <b>{{user?.supportNumber}}</b></span>
        </a>
        <div *ngIf="entities.activeTopbarAction === 'ShowSupport'" class="iam-topbar-action-panel p-shadow-6 p-p-3">
          <div class="">
            <div class="p-col-12" style="border-bottom: 1px solid #1492e6;">
              <b style="line-height: 20px;display: inline-block;">Thông tin đại lý</b>
            </div>
            <div class="p-col-12 pointer">Mã đại lý:  {{user.supportPseudoId}}</div>
            <div class="p-col-12 pointer">Tên đại lý: {{user.supportPartyName}}</div>
            <div class="p-col-12" style="border-top: 1px solid #1492e6;">
              <b style="line-height: 20px;display: inline-block;">Hotline công ty: {{user.hotlineOrganization}}</b>
            </div>
          </div>
        </div>
      </li>
      <li class="iam-topbar-action">
        <p-button label="{{ decreeAndCircularUsing === 'DecCir32' ? 'Nâng cấp lên TT78 - NĐ 123/2020/NĐ-CP' : 'Chuyển về TT32 - NĐ51' }}"
                  styleClass="p-button-outlined p-button-help p-button-rounded" (onClick)="toggleDecreeCircular()"
                  *ngIf="AuthService.hasRoles(['Customer']) && decreeAndCircularUsing === 'DecCir32'"></p-button>
        <a pRipple class="rounded-circle" (click)="entities.onTopbarActionClick($event, 'QuickCreate')" title="{{ 'QuickCreate'|translate }}"
           *ngIf="AuthService.hasRoles(['Customer'])">
          <i class="pi pi-plus-circle pi-large"></i>
        </a>
        <div *ngIf="entities.activeTopbarAction === 'QuickCreate'" class="iam-topbar-action-panel p-shadow-6 p-p-3">
          <div class="p-mb-3">
            <span style="font-size: 20px;">{{ 'QuickCreate'|translate }}</span>
          </div>
          <div class="p-d-flex">
            <div class="p-mr-5" style="width: 140px;">
              <div class="p-grid">
                <div class="p-col-12">
                  <b style="border-bottom: 1px solid #1492e6;line-height: 20px;display: inline-block;">{{ 'Invoice'|translate }}</b>
                </div>
                <div class="p-col-12 pointer" routerLink="/customer/invoice/hdbh/create">Hóa đơn bán hàng</div>
              </div>
            </div>
            <div class="p-mr-5" style="width: 140px;">
              <div class="p-grid">
                <div class="p-col-12">
                  <b style="border-bottom: 1px solid #1492e6;line-height: 20px;display: inline-block;">{{ 'HandleInvoice'|translate }}</b>
                </div>
                <div class="p-col-12 pointer" routerLink="/customer/invoice/cancelled">Hủy hóa đơn</div>
                <div class="p-col-12 pointer" routerLink="/customer/invoice/replaced">Thay thế hóa đơn</div>
                <div class="p-col-12 pointer" routerLink="/customer/invoice/adjusted">Điều chỉnh hóa đơn</div>
              </div>
            </div>
            <div class="p-mr-5" style="width: 230px;">
              <div class="p-grid">
                <div class="p-col-12">
                  <b style="border-bottom: 1px solid #1492e6;line-height: 20px;display: inline-block;">{{ 'RegisterToIssue'|translate }}</b>
                </div>
                <div class="p-col-12 pointer" routerLink="/customer/register/invoice-templates/create">Mẫu hóa đơn</div>
                <!--                <div class="p-col-12">Quyết định áp dụng HĐĐT</div>-->
                <div class="p-col-12 pointer" routerLink="/customer/register/release-announcement/create">Thông báo phát hành HĐ</div>
                <!--                <div class="p-col-12">Thông báo hủy hóa đơn</div>-->
                <!--                <div class="p-col-12">Thông báo điều chỉnh thông tin HĐ</div>-->
              </div>
            </div>
            <div style="width: 140px;">
              <div class="p-grid">
                <div class="p-col-12">
                  <b style="border-bottom: 1px solid #1492e6;line-height: 20px;display: inline-block;">{{ 'Dictionary'|translate }}</b>
                </div>
                <div class="p-col-12 pointer" routerLink="/customer/category/buyers/create">Khách hàng</div>
                <div class="p-col-12 pointer" routerLink="/customer/category/products/create">Hàng hóa, dịch vụ</div>
              </div>
            </div>
          </div>
        </div>
      </li>
      <li class="iam-topbar-action">
        <a pRipple class="rounded-circle" (click)="viewNotification($event)" title="Thông báo"
           *ngIf="AuthService.hasRoles(['Customer'])">
          <i class="pi pi-bell pi-large"></i>
          <span class="p-badge p-badge-no-gutter p-badge-success" style=" position: absolute; right: 0; top: 0; padding: 0 2px 0 2px;">{{ noticeCount|number }}</span>
        </a>
        <div *ngIf="entities.activeTopbarAction === 'Notification'" class="iam-topbar-action-panel p-shadow-6 p-p-3">
          <div class="p-mb-3">
            <span style="font-size: 20px;">{{ 'Thông báo'|translate }}</span>
          </div>
          <div class="p-grid iam-scroll" style="width: 30rem; max-height: 400px; overflow: hidden auto;">
            <div class="p-col-12" *ngFor="let notification of notifications">
              <div class="p-card">
                <div class="p-grid p-px-3">
                  <div class="p-col-1 p-pb-0">
                    <i class="pi pi-volume-up" style="margin: 3px; font-size: 19px; color: #0c5460;" *ngIf="notification['typeString'] === 'info'"></i>
                    <i class="pi pi-exclamation-circle" style="margin: 3px; font-size: 19px; color: #FF9800;" *ngIf="notification['typeString'] === 'warning'"></i>
                  </div>
                  <div class="p-col-11 p-pb-0">
                    <div class="p-grid">
                      <div class="p-col-12" [innerHtml]="notification['titleText']|safeHtml"></div>
                      <div class="p-col-12">
                        <div class="p-grid">
                          <div class="p-col-6">
                            <span class="alert-success pointer" (click)="viewNotificationDetail(notification)" *ngIf="notification['topic'] === 'GeneralNotification'">Xem chi tiết</span>
                          </div>
                          <div class="p-col-6">
                            <p class="p-mb-0 p-text-right"><i>{{ notification['sentDate']|date:'dd/MM/yyyy HH:mm:ss' }}</i></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
      <li class="iam-topbar-action">
        <a pRipple class="rounded-circle" (click)="entities.onTopbarActionClick($event, 'Profile')" title="{{ 'Profile'|translate }}">
          <i class="pi pi-user pi-large"></i>
          <span class="p-ml-2" *ngIf="user">{{ displayName }}</span>
        </a>
        <ul *ngIf="entities.activeTopbarAction === 'Profile'" class="iam-topbar-action-panel p-shadow-6">
          <li class="layout-topbar-action-item">
            <a pRipple class="p-d-flex p-flex-row p-ai-center" (click)="changePassword()">
              <i class="pi pi-unlock p-mr-2"></i>
              <span>{{ 'ChangePassword'|translate }}</span>
            </a>
          </li>
          <li class="layout-topbar-action-item">
            <a pRipple class="p-d-flex p-flex-row p-ai-center" (click)="logout()">
              <i class="pi pi-power-off p-mr-2"></i>
              <span>{{ 'Logout'|translate }}</span>
            </a>
          </li>
          <li class="p-pt-2 p-pr-3 p-pl-3 p-text-center">
            <span style="font-size: 12px;color: #616161;">{{ user['partyName'] }}</span>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</div>

<p-dialog header="Nhắc đổi mật khẩu" [(visible)]="passwordWarningVisible"
          styleClass="password-expiry-dialog"
          [style]="{width: '440px', maxWidth: 'calc(100vw - 2rem)'}" [modal]="true" [resizable]="false"
          (onHide)="dismissPasswordWarning()">
  <div class="password-expiry-content">
    <div class="password-expiry-icon" aria-hidden="true"><i class="pi pi-lock"></i></div>
    <div class="password-expiry-copy">
      <p class="password-expiry-status" *ngIf="user?.passwordDaysRemaining > 0">
        Còn {{ user.passwordDaysRemaining }} ngày
      </p>
      <p class="password-expiry-status" *ngIf="user?.passwordDaysRemaining === 0">Đã đến hạn</p>
      <p class="password-expiry-message" *ngIf="user?.passwordDaysRemaining > 0">
        Mật khẩu cũ của bạn còn hạn <strong>{{ user.passwordDaysRemaining }} ngày</strong>.
      </p>
      <p class="password-expiry-message" *ngIf="user?.passwordDaysRemaining === 0">
        Mật khẩu của bạn đã đến hạn đổi.
      </p>
      <p class="password-expiry-hint">
        Vui lòng đổi mật khẩu <button type="button" class="password-expiry-link"
                                       (click)="openPasswordChangeFromWarning()">ở đây</button>.
      </p>
    </div>
  </div>
  <p-footer>
    <p-button label="Để sau" styleClass="p-button-text p-button-secondary"
              (onClick)="dismissPasswordWarning()"></p-button>
    <p-button label="Đổi mật khẩu" icon="pi pi-lock" (onClick)="openPasswordChangeFromWarning()"></p-button>
  </p-footer>
</p-dialog>

<form [formGroup]="changePasswordForm" (ngSubmit)="onChangePassword()">
  <p-dialog header="{{ 'ChangePassword'|translate }}" [(visible)]="changingPassword" [style]="{width: '500px'}" [resizable]="false" position="top">
    <p-message severity="info" text="Xin quý khách lưu ý, để đảm bảo an ninh tài khoản nên dùng một mật khẩu đầy đủ yếu tố sau: Sử dụng ít nhất 8 ký tự, bao gồm chữ hoa, chữ thường và số."></p-message>
    <div class="p-fluid p-formgrid p-grid p-mt-2">
      <div class="p-field p-col-12">
        <label for="oldPassword">{{ 'Password'|translate }}<span class="required">*</span></label>
        <p-password id="oldPassword" formControlName="oldPassword" [toggleMask]="true" [feedback]="false"></p-password>
        <app-validator [control]="changePasswordForm.get('oldPassword')"></app-validator>
      </div>
      <div class="p-field p-col-12">
        <label for="newPassword">{{ 'NewPassword'|translate }}<span class="required">*</span></label>
        <p-password id="newPassword" formControlName="newPassword" [toggleMask]="true" [feedback]="false"></p-password>
        <app-validator [control]="changePasswordForm.get('newPassword')"></app-validator>
      </div>
      <div class="p-field p-col-12">
        <label for="newPasswordVerify">{{ 'NewPasswordVerify'|translate }}<span class="required">*</span></label>
        <p-password id="newPasswordVerify" formControlName="newPasswordVerify" [toggleMask]="true" [feedback]="false"></p-password>
        <app-validator [control]="changePasswordForm.get('newPasswordVerify')"></app-validator>
      </div>
    </div>
    <p-message severity="error" [text]="changePasswordError" *ngIf="changePasswordError"></p-message>
    <p-footer>
      <p-button label="{{ 'ChangePassword'|translate }}" icon="pi pi-check" styleClass="p-button-raised" type="submit" [disabled]="changePasswordForm.invalid"></p-button>
      <p-button label="{{ 'Close'|translate }}" icon="pi pi-times" styleClass="p-button-raised p-button-text p-button-plain" (onClick)="changingPassword=false"></p-button>
    </p-footer>
  </p-dialog>
</form>
<p-dialog header="Chọn gói dịch vụ Nâng cấp" [(visible)]="productList" [style]="{width: '1000px'}" [resizable]="false" position="top">
  <p-table [value]="items" [selectionMode]="selectionMode" [(selection)]="selectedItem"
           (onRowSelect)="selectedItem = $event.data"
           styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines">
    <ng-template pTemplate="header">
      <tr>
        <th [width]="40" class="p-text-center">#</th>
        <th [width]="160">{{ 'Mã gói'|translate }}</th>
        <th>{{ 'Tên gói'|translate }}</th>
        <th>{{ 'Số lượng'|translate }}</th>
        <th>{{ 'Đơn giá'|translate }}</th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-index="rowIndex">
      <tr>
        <td class="p-text-center">{{ (index + 1)|number }}</td>
        <td>{{ rowData['pseudoId'] }}</td>
        <td>{{ rowData['productName'] }}</td>
        <td class="p-text-right">{{ rowData['amountValue'] }}</td>
        <td class="p-text-right">{{ rowData['price']|number }}</td>
        <td>
          <p-tableRadioButton [value]="rowData" *ngIf="selectionMode === 'single'"></p-tableRadioButton>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <p-footer>
    <p-button label="Thanh toán" icon="pi pi-check" styleClass="p-button-raised"
              (onClick)="openPaymentInfo(selectedItem)" [disabled]="!selectedItem"></p-button>
    <p-button label="{{ 'Close'|translate }}" icon="pi pi-times" styleClass="p-button-raised p-button-text p-button-plain" (onClick)="productList=false"></p-button>
  </p-footer>
</p-dialog>

<p-dialog header="Thông tin thanh toán" [(visible)]="paymentInfoVisible" [style]="{width: '600px'}" [modal]="true"
          [resizable]="false" position="top">
  <div *ngIf="currentPaymentItem" class="p-fluid">
    <p-table [value]="[currentPaymentItem]" styleClass="p-datatable-sm p-datatable-gridlines p-mb-4">
      <ng-template pTemplate="header">
        <tr>
          <th>Gói dịch vụ đã chọn</th>
          <th>Đơn giá</th>
          <th>Thành tiền</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData>
        <tr>
          <td>{{ rowData.productName }}</td>
          <td class="p-text-right">{{ rowData.price | number }}</td>
          <td class="p-text-right">{{ rowData.price | number }}</td>
        </tr>
      </ng-template>
    </p-table>

    <form [formGroup]="paymentInfoForm" (ngSubmit)="confirmPayment()">
      <div class="p-field p-grid p-mt-4">
        <label for="orgRepName" class="p-col-12 p-md-4" style="align-self: center; margin-bottom: 0;">Tên người liên hệ</label>
        <div class="p-col-12 p-md-8">
          <input pInputText id="orgRepName" type="text" formControlName="orgRepName">
          <app-validator [control]="paymentInfoForm.get('orgRepName')"></app-validator>
        </div>
      </div>
      <div class="p-field p-grid p-mt-2">
        <label for="contactNumber" class="p-col-12 p-md-4" style="align-self: center; margin-bottom: 0;">Số điện thoại<span class="required">*</span></label>
        <div class="p-col-12 p-md-8">
          <input pInputText id="contactNumber" type="text" formControlName="contactNumber" maxlength="10"
                 (keypress)="($event.charCode >= 48 && $event.charCode <= 57)">
          <app-validator [control]="paymentInfoForm.get('contactNumber')"></app-validator>
        </div>
      </div>
      <div class="p-field p-grid p-mt-2">
        <label for="emailAddress" class="p-col-12 p-md-4" style="align-self: center; margin-bottom: 0;">Email (Nhận hoá đơn)<span class="required">*</span></label>
        <div class="p-col-12 p-md-8">
          <input pInputText id="emailAddress" type="text" formControlName="emailAddress">
          <app-validator [control]="paymentInfoForm.get('emailAddress')"></app-validator>
        </div>
      </div>
    </form>
  </div>
  <p-footer>
    <p-button label="Xác nhận" icon="pi pi-check" styleClass="p-button-raised" (onClick)="confirmPayment()"
              [disabled]="paymentInfoForm.invalid"></p-button>
    <p-button label="Đóng" icon="pi pi-times" styleClass="p-button-raised p-button-text p-button-plain"
              (onClick)="paymentInfoVisible=false"></p-button>
  </p-footer>
</p-dialog>

<p-dialog header="Quét mã để thanh toán" [(visible)]="displayQR" [style]="{width: '500px'}" [resizable]="false" position="top">
  <div style="display: flex; flex-direction: column; align-items: center; width: 100%; padding-top: 20px;">
    <img src="assets/iam/logo-napas/Logo/Logo%20VietQR.png" alt="VietQR" style="height: 80px" />
    <div style="border: 2px solid #0a6b57; padding: 2px; display: inline-block;">
      <img [src]="QRdata" alt="QR Code" style="height: 14rem;" />
    </div>
    <div style="text-align: center; color: #0a6b57;">
      <div style="display: flex; align-items: center; justify-content: center; gap: 10px; font-weight: bold; font-size: 1.2rem;">
        <img src="assets/iam/logo-napas/Logo/Napas247%20logo.png" alt="Napas247" style="height: 50px;" />
      </div>
      <div style="font-weight: bold; margin-bottom: 8px;">{{merchantName}}</div>
      <div style="font-weight: bold; margin-bottom: 8px;">Thanh toán đơn hàng mã {{paymentRefNum}}</div>
      <div>Số tiền: {{amount|number}} VND</div>
    </div>
  </div>
  <p-footer>
    <p-button label="{{ 'Close'|translate }}" icon="pi pi-times" styleClass="p-button-raised p-button-text p-button-plain" (onClick)="displayQR=false"></p-button>
  </p-footer>
</p-dialog>

<p-dialog header="" [(visible)]="paymentSuccessVisible" [style]="{width: '700px'}" [resizable]="false" position="top" [closable]="true">
  <div class="container">
    <div style="background: white; width: 100%; position: relative;">
      <div style="width: 120px; height: 120px; margin: 0 auto 20px; background-color: #7bc025; border-radius: 50%; display: flex; align-items: center; justify-content: center; position: relative; overflow: hidden;">
        <div style="position: absolute; width: 61px; height: 60px; background: rgba(0, 0, 0, 0.15); transform: rotate(45deg); top: 55px; left: 60px; z-index: 1;"></div>
        <div style="width: 32px; height: 60px; border-bottom: 11px solid white; border-right: 11px solid white; transform: rotate(45deg); margin-bottom: 15px; margin-right: 5px; border-bottom-right-radius: 4px; border-bottom-left-radius: 4px; border-top-right-radius: 4px; z-index: 2;"></div>
      </div>
      <h2 style="text-align: center; color: #5ea81b; font-size: 32px; margin-bottom: 25px; font-weight: 800;">Thanh toán thành công !</h2>
      <p style="text-align: center; color: #1a1a1a; font-size: 18px; line-height: 1.6; margin-bottom: 25px; font-weight: 500; padding: 0 10px;">
        Quý khách đã thanh toán đơn hàng có mã <span style="color: #0b4b8b;">{{paymentRefNum}}</span>, gói dịch vụ <span style="color: #0b4b8b;">{{title}}</span> thành công. Số lượng<br>
        hóa đơn mới đã được cập nhật đầy đủ vào tài khoản. Quý khách có thể<br>
        bắt đầu sử dụng ngay từ bây giờ.
      </p>
      <p style="text-align: center; color: #1a1a1a; font-size: 18px; line-height: 1.6; font-style: italic; font-weight: 500; margin-top: 20px;">
        Chúc Quý khách một ngày làm việc hiệu quả!
      </p>
    </div>
  </div>
  <p-footer>
    <p-button label="{{ 'Close'|translate }}" icon="pi pi-times" styleClass="p-button-raised p-button-text p-button-plain" (onClick)="paymentSuccessVisible=false"></p-button>
  </p-footer>
</p-dialog>
<p-dialog [(visible)]="titleText" [style]="{width: '890px'}" header="{{titleText}}" [resizable]="false" position="top">
  <!--<h4>{{header}}</h4>-->
  <ng-container *ngIf="notification">
    <div [innerHtml]="notification['detailText']|safeHtml"></div>
  </ng-container>

  <p-footer>
    <p-button label="{{ 'Close'|translate }}" icon="pi pi-times" styleClass="p-button-raised p-button-text p-button-plain" (onClick)="titleText=undefined"></p-button>
  </p-footer>
</p-dialog>
